import styled from 'styled-components';

export const RoundListCircle = styled.span`
  width: 12px;
  height: 12px;
  background: rgb(0 0 0 / 12%);
  display: inline-block;
  border-radius: 50%;
  margin-right: 3px;
`;
